<template>
  <div id="app">
    <topbar v-if="logged" />
    <Navbar
      v-if="logged"
      class="hidden-large"
    />

    <Navbar
      v-if="logged"
      v-on-clickaway="hideNavbar"
      :class="navBarClass"
    />

    <div
      :class="['container-fluid', {
        'content': logged,
      }]"
    >
      <sound-recordings-list v-if="pageNotFound" />
      <router-view v-else :key="$route.path" />
    </div>
  </div>
</template>

<!--Third Party plugin css-->
<style lang="scss">
@import "assets/styles/base.scss";
@import "assets/fonts/fontawesome-pro-5.7.0-web/css/all.min.css";
</style>

<script>
import {
  faCheckCircle,
  faExclamationCircle,
  faPen,
  faQuestionCircle,
  faTimes,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"
import { mapGetters, mapMutations, mapState } from "vuex"
import ActionButton from "./components/Modules/ActionButton"
import ClaimConfirmationModal from "./components/Modules/ClaimConfirmationModal.vue"
import ClaimsModal from "./components/Modules/ClaimsModal.vue"
import ClaimsTable from "./components/Modules/ClaimsTable.vue"
import DatePicker from "vue2-datepicker"
import Dropzone from "./components/Modules/Dropzone.vue"
import FileErrorsTable from "./components/Modules/FileErrorsTable.vue"
import FilterModule from "./components/Modules/FilterModule.vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import ListTablePopover from "./components/Modules/ListTablePopover.vue"
import MandatesSelector from "./components/Modules/MandatesSelector.vue"
import Modal from "./components/Layout/Modal.vue"
import Multiselect from "vue-multiselect"
import Navbar from "./components/Layout/Navbar.vue"
import PlaylistSelector from "./components/Modules/PlaylistSelector.vue"
import PrettyCheck from "pretty-checkbox-vue/check"
import RecordingDetails from "./components/Modules/RecordingDetails.vue"
import ReleaseNames from "./components/Modules/ReleaseNames.vue"
import SelectRecordTable from "./components/Modules/SelectRecordTable.vue"
import SelectedFilters from "./components/Modules/SelectedFilters.vue"
import SoundRecordingsList from "@/components/Pages/repertoire/SoundRecordingsList"
import Status from "./components/Modules/Status.vue"
import TopSection from "./components/Layout/TopSection.vue"
import Vue from "vue"
import VueAvatar from "vue-avatar"
import VueFooter from "./components/Layout/Footer.vue"
import { mixin as clickaway } from "vue-clickaway"
import { library } from "@fortawesome/fontawesome-svg-core"
import loader from "./components/Modules/loader.vue"
import spinner from "./components/Modules/spinner.vue"
import topbar from "./components/Layout/TopBar.vue"

library.add(
  faCheckCircle,
  faExclamationCircle,
  faPen,
  faQuestionCircle,
  faTimes,
  faTrash
)

// register components globally
Vue.component("Avatar", VueAvatar)
Vue.component("spinner", spinner)
Vue.component("loader", loader)
Vue.component("ReleaseNames", ReleaseNames)
Vue.component("Multiselect", Multiselect)
Vue.component("SelectRecordTable", SelectRecordTable)
Vue.component("DatePicker", DatePicker)
Vue.component("MandatesSelector", MandatesSelector)
Vue.component("PlaylistSelector", PlaylistSelector)
Vue.component("Navbar", Navbar)
Vue.component("topbar", topbar)
Vue.component("VueFooter", VueFooter)
Vue.component("Dropzone", Dropzone)
Vue.component("ClaimsModal", ClaimsModal)
Vue.component("ClaimsTable", ClaimsTable)
Vue.component("RecordingDetails", RecordingDetails)
Vue.component("ClaimConfirmationModal", ClaimConfirmationModal)
Vue.component("Modal", Modal)
Vue.component("TopSection", TopSection)
Vue.component("FileErrorsTable", FileErrorsTable)
Vue.component("FilterModule", FilterModule)
Vue.component("fa-icon", FontAwesomeIcon)
Vue.component("SelectedFilters", SelectedFilters)
Vue.component("Status", Status)
Vue.component("p-check", PrettyCheck)
Vue.component("ListTablePopover", ListTablePopover)
Vue.component("action-button", ActionButton)

Vue.component("divider", {
  template: "<hr class=\"divider\"/>"
})

export default {
  name: "App",

  components: {
    SoundRecordingsList,
    Navbar,
  },
  mixins: [clickaway],

  mounted () {
    let referrer = document.referrer
    this.setReferrer(referrer)
    this.setSocietyFromReferrer(referrer)

    let logged = this.getIsAuth()
    if (logged) {
      this.$store.commit("soundsys/setLogged", logged)
    }
  },

  methods: {
    ...mapMutations("members", ["setReferrer", "setSocietyFromReferrer"]),
    ...mapMutations("ui", ["toggleNavbar"]),

    getNavbarClass () {
      if (this.showNavbar === "initial") return
      if (this.showNavbar) {
        return "on"
      }
      return " off"
    },
    getIsAuth () {
      let expiresAt = localStorage.getItem("expires_at")
      return new Date().getTime() < expiresAt
    },
    hideNavbar (e) {
      e.stopPropagation()
      if (this.showNavbar !== "initial" && this.showNavbar) {
        this.toggleNavbar("close")
      }
    },

  },
  computed: {
    ...mapState("soundsys", ["logged", "user", "pageNotFound"]),
    ...mapState("ui", ["showNavbar"]),
    ...mapGetters("members", ["society"]),

    navBarClass () {
      if (this.showNavbar === "initial") {
        return ["responsive-navbar"]
      }

      return ["responsive-navbar", {
        "on": this.showNavbar,
        "off": !this.showNavbar,
      }]
    }
  },
}
</script>
